import { computed, onMounted, onUnmounted, ref } from 'vue'

type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'

export function useBreakpoint() {
  const breakpoints: Record<Breakpoint, number> = {
    xs: 0,
    sm: 575,
    md: 767,
    lg: 1023,
    xl: 1279,
    xxl: 1439
  }

  const getBreakpoint = (): Breakpoint => {
    const width = window.innerWidth
    const breakpointEntries = Object.entries(breakpoints).reverse() as [Breakpoint, number][]
    const [breakpoint] = breakpointEntries.find(([_, value]) => width >= value) || ['xs', 0]
    return breakpoint
  }

  const breakpoint = ref<Breakpoint>(getBreakpoint())

  const updateBreakpoint = () => {
    breakpoint.value = getBreakpoint()
  }

  onMounted(() => {
    window.addEventListener('resize', updateBreakpoint)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', updateBreakpoint)
  })

  const getCurrentBreakpoint = computed(() => breakpoint.value)

  const isMobile = computed(() => {
    return ['xs', 'sm'].includes(breakpoint.value)
  })

  const isDesktop = computed(() => {
    return ['lg', 'xl', 'xxl'].includes(breakpoint.value)
  })

  // Add more breakpoint-functions if needed

  return { breakpoint, getCurrentBreakpoint, isMobile, isDesktop }
}
